import AppFav from '../app-fav'
import CoreVideoPlayer from '../core-video-player'

export default
{
    components:
    {
        AppFav,
        CoreVideoPlayer
    },

    props:
    {
        content: { type: Object, default: null },
        magmaContent: { type: Array, default: null },
        isSwitching: { type: Boolean, default: false }
    },

    watch:
    {
        isSwitching: 'onModalSwitch'
    },

    data()
    {
        return {
            prev: {
                post_type: '',
                post_name: ''
            },

            next: {
                post_type: '',
                post_name: ''
            },

            hasLocalisation: false,
            isFullscreen: false,
            videoCurrentTime: 0
        }
    },

    created()
    {
        this.eventHub.$on('window:resize', this.onResize)
        this.eventHub.$on('keydown', this.onKeyDown)
    },

    mounted()
    {
        this.$content = this.$el.querySelector('.js-content')
        this.$gallery = this.$el.querySelector('.js-gallery')

        if(this.content.localisation)
        {
            for(let i = 0; i < this.content.categories.length; i++)
            {
                if(this.content.categories[i].slug.indexOf('conference') !== -1)
                {
                    this.hasLocalisation = true
                }
            }
        }


        this.getRelatedContent()

        setTimeout(() =>
        {
            this.onResize()
        }, 50)
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this.onResize)
        this.eventHub.$off('keydown', this.onKeyDown)
    },

    methods:
    {
        onSetFullscreen(currentTime)
        {
            this.isFullscreen = true
            this.videoCurrentTime = currentTime
        },

        onRemoveFullscreen(currentTime)
        {
            this.isFullscreen = false
            this.videoCurrentTime = currentTime
        },

        onModalSwitch()
        {
            if(!this.isSwitching)
            {
                this.$nextTick(() =>
                {
                    this.$content = this.$el.querySelector('.js-content')
                    this.getRelatedContent()
                })

                setTimeout(() =>
                {
                    this.onResize()
                }, 50)
            }
        },

        onKeyDown(keycode)
        {
            if(keycode === 37)
            {
                if(this.prev.post_type !== '')
                {
                    this.$router.push('/' + this.prev.post_type + '/' + this.prev.post_name)
                }
            }

            if(keycode === 39)
            {
                if(this.next.post_type !== '')
                {
                    this.$router.push('/' + this.next.post_type + '/' + this.next.post_name)
                }
            }

            if(keycode === 27)
            {
                if(this.isFullscreen)
                {
                    this.isFullscreen = false
                }
                else
                {
                    this.$router.push(this.$root.currentPath === 'home' ? '/' : '/' + this.$root.currentPath)
                }
            }
        },

        getRelatedContent()
        {
            let relatedContent = []

            if(this.$root.currentPath !== 'my-selection')
            {
                for(let i = 0; i < this.magmaContent.length; i++)
                {
                    if(this.magmaContent[i].post_type === 'article' || this.magmaContent[i].post_type === 'medias' || this.magmaContent[i].post_type === 'agency')
                    {
                        if(this.magmaContent[i].post_name !== this.content.post_name)
                        {
                            relatedContent.push(this.magmaContent[i])
                        }
                    }
                }

                if(relatedContent.length > 0)
                {
                    this._prevRandomIndex = this.getRandomInt(0, relatedContent.length)

                    this.prev.post_type = relatedContent[this._prevRandomIndex].post_type
                    this.prev.post_name = relatedContent[this._prevRandomIndex].post_name
                }

                if(relatedContent.length > 1)
                {
                    this._nextRandomIndex = this.getRandomInt(0, relatedContent.length, this._prevRandomIndex)

                    this.next.post_type = relatedContent[this._nextRandomIndex].post_type
                    this.next.post_name = relatedContent[this._nextRandomIndex].post_name
                }
            }
            else
            {
                for(let i = 0; i < this.magmaContent.length; i++)
                {
                    if(this.magmaContent[i].post_type === 'article' || this.magmaContent[i].post_type === 'medias' || this.magmaContent[i].post_type === 'agency')
                    {
                        if(this.magmaContent[i].post_name === this.content.post_name)
                        {
                            if(this.magmaContent[i - 1])
                            {
                                this.prev.post_type = this.magmaContent[i - 1].post_type
                                this.prev.post_name = this.magmaContent[i - 1].post_name
                            }
                            else
                            {
                                this.prev.post_type = ''
                            }

                            if(this.magmaContent[i + 1])
                            {
                                this.next.post_type = this.magmaContent[i + 1].post_type
                                this.next.post_name = this.magmaContent[i + 1].post_name
                            }
                            else
                            {
                                this.next.post_type = ''
                            }
                        }
                    }
                }
            }

        },

        onResize()
        {
            this._height = this.$content.offsetHeight

            if(this._height >= this.$root.window.height)
            {
                this.$el.classList.add('is-padded')
            }
            else
            {
                this.$el.classList.remove('is-padded')
            }

            if(this.$gallery)
            {
                this._galleryHeight = this.$gallery.offsetHeight
            }
        },

        getRandomInt(min, max, exept)
        {
            const rand = Math.floor(Math.random() * max) + min
            return rand === exept ? this.getRandomInt(min, max, exept) : rand
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-modal-post/script.js